export const CHAT_MESSAGE_TEST_IDS = {
  userMessage: 'chatbot-user-message',
  aiMessage: 'chatbot-ai-message',
  fileList: 'chatbot-file-list',
  fileLink: 'chatbot-file-link',
};
